export class PageData {
  public customerId : string;
  public pageData : any;
}
